// Carrito del visitante: vive en su navegador hasta que aparta. El servidor vuelve a decidir lugares, precios y promociones al apartar.
export type LineaCarrito = {
  salidaId: string; tour: string; slug: string; fecha: string; hora: string;
  adultos: number; ninos: number; adultoCentavos: number; ninoCentavos: number; porVuelo: boolean;
  /** Edad de cada menor y lo que suman según las reglas del tour (para mostrar el subtotal antes de apartar). */
  edades?: number[]; menoresCentavos?: number;
};
export const CLAVE_CARRITO = "sierra-tours-carrito-v1";
export const EVENTO_CARRITO = "sierra-tours-carrito";
export const MAX_LINEAS_CARRITO = 6;

const hay = () => typeof window !== "undefined";
const valida = (x: unknown): x is LineaCarrito => {
  const l = x as LineaCarrito;
  return !!l && typeof l.salidaId === "string" && typeof l.tour === "string" && typeof l.slug === "string" && /^\d{4}-\d{2}-\d{2}$/.test(l.fecha) && typeof l.hora === "string"
    && Number.isInteger(l.adultos) && l.adultos >= 1 && l.adultos <= 40 && Number.isInteger(l.ninos) && l.ninos >= 0 && l.ninos <= 40
    && Number.isInteger(l.adultoCentavos) && Number.isInteger(l.ninoCentavos) && typeof l.porVuelo === "boolean"
    && (l.edades === undefined || (Array.isArray(l.edades) && l.edades.length === l.ninos && l.edades.every((e) => Number.isInteger(e) && e >= 0 && e <= 17))) && (l.menoresCentavos === undefined || Number.isInteger(l.menoresCentavos));
};

export function leerCarrito(): LineaCarrito[] {
  if (!hay()) return [];
  try { const j = JSON.parse(localStorage.getItem(CLAVE_CARRITO) ?? "[]"); return Array.isArray(j) ? j.filter(valida).slice(0, MAX_LINEAS_CARRITO) : []; } catch { return []; }
}
function guardar(l: LineaCarrito[]) {
  if (!hay()) return;
  try { localStorage.setItem(CLAVE_CARRITO, JSON.stringify(l)); } catch { /* sin almacenamiento: el carrito no se conserva */ }
  window.dispatchEvent(new Event(EVENTO_CARRITO));
}
/** Agrega la salida; si ya estaba, actualiza las personas. Devuelve false si el carrito está lleno. */
export function agregarAlCarrito(linea: LineaCarrito): boolean {
  const actual = leerCarrito(), i = actual.findIndex((x) => x.salidaId === linea.salidaId);
  if (i < 0 && actual.length >= MAX_LINEAS_CARRITO) return false;
  if (i >= 0) actual[i] = linea; else actual.push(linea);
  guardar(actual); return true;
}
export const quitarDelCarrito = (salidaId: string) => guardar(leerCarrito().filter((x) => x.salidaId !== salidaId));
export const vaciarCarrito = () => guardar([]);
export const subtotalLinea = (l: LineaCarrito) => l.porVuelo ? l.adultoCentavos : l.adultos * l.adultoCentavos + (l.menoresCentavos ?? l.ninos * l.ninoCentavos);

/** Mismo identificador que usa «Mi visita» para un tour: une el plan del día con el pago conjunto. */
export const idVisitaDe = (l: Pick<LineaCarrito, "slug" | "fecha" | "hora">) => `tour-${l.slug}-${l.fecha}-${l.hora}`;
